import { Controller } from 'stimulus'
import fetchClient from "../plugins/fetchClient";

// TODO: если получится апнуть пакеты и включить турбо, перевести на турбо
export default class extends Controller {
  static values = { baseUrl: String }

  connect() {
    const modal = document.getElementById('timeslotsModal')
    this.modalController = this.application
                               .getControllerForElementAndIdentifier(modal, 'modal')
    // Текущая услуга - задаётся при открытии модалки
    this.serviceId = null
    this.serviceGuid = null
    // Для конкретной услуги таймслоты и цены по клиникам подтягиваются при открытии модалки
    this.timeslotsByService = {}
    this.pricesByService = {}
  }

  async fetchTimeslots() {
    if (!this.timeslotsByService[this.serviceId] || this.timeslotsByService[this.serviceId] == {}) {
      this.timeslotsByService[this.serviceId] = await fetchClient(`/services/${this.serviceId}/nearest_clinic_timeslots`)
    }
    if (!this.pricesByService[this.serviceId] || this.pricesByService[this.serviceId] == {}) {
      this.pricesByService[this.serviceId] = await fetchClient(`/services/${this.serviceId}/city_prices`)
    }
    this.fillContainers()
  }

  timeslotsArePresent() {
    this.timeslotsByClinic && Object.values(this.timeslotsByClinic).some(ts => { ts.length > 0 })
  }

  fillContainers() {
    const clinicContainers = document.querySelectorAll('.clinic-container')
    clinicContainers.forEach(clinicContainer => {
      const clinicId = +clinicContainer.dataset.clinicId
      const clinicGuid = clinicContainer.dataset.clinicGuid
      const timeslots = this.timeslotsByService?.[this.serviceId]?.[clinicId]
      const orderLinkEl = clinicContainer.querySelector('.order-link')
      // Задаём ссылку на запись
      orderLinkEl.href = this.getOrderUrl(clinicGuid)
      const timeslotContainer = clinicContainer.querySelector('.timeslot-container')
      const noTimeslotsMessageEl = clinicContainer.querySelector('.no-timeslots-message')
      if (timeslots) {
        // Задаём цену
        const priceEl = clinicContainer.querySelector('.clinic-price')
        priceEl.innerHTML = this.format_price(this.pricesByService?.[this.serviceId]?.[clinicId])
        const timeslotDivs = timeslotContainer.querySelectorAll('.timeslot')
        // Слоты есть - скрываем сообщение об отсутствии, показываем слоты
        clinicContainer.classList.remove('hidden')
        noTimeslotsMessageEl.classList.add('hidden')
        if (timeslots.length > 0) {
          timeslotContainer.classList.remove('hidden')
          // Задаём таймслоты
          timeslotDivs.forEach((timeSlotDiv, index) => {
            if (index < timeslots.length) {
              const span = timeSlotDiv.querySelector('span')
              span.innerText = timeslots[index]
            } else {
              timeSlotDiv.classList.add('hidden')
            }
          })
        } else {
          // Слотов нет - показываем сообщение
          timeslotContainer.classList.add('hidden')
          noTimeslotsMessageEl.classList.remove('hidden')
        }
      } else {
        // Услуга не оказывается в этой клинике - скрываем клинику
        clinicContainer.classList.add('hidden')
      }
    })
  }

  getOrderUrl(clinicGuid) {
    return `${this.baseUrlValue}?clinic_guid=${clinicGuid}&service_guid=${this.serviceGuid}`
  }

  format_price(price) {
    if (!price) { return '-' }

    const numberFormat = new Intl.NumberFormat('ru-RU')
    return numberFormat.format(price) + ' ₽'
  }

  async openModal(e) {
    e.target.disabled = true
    if (this.serviceId !== e.target.dataset.serviceId) {
      this.serviceId = e.target.dataset.serviceId
      this.serviceGuid = e.target.dataset.serviceGuid
      await this.fetchTimeslots()
    }
    if (!this.modalController) {
      const modal = document.getElementById('timeslotsModal')
      this.modalController = this.application
                                 .getControllerForElementAndIdentifier(modal, 'modal')
    }
    this.modalController.open()
    e.target.disabled = false
  }
}
